import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import KButton from '@kso/ui/lib/Button';
import '@kso/ui/lib/Button/style.css';
import KFinderAside from '@kso/ui/lib/FinderAside';
import '@kso/ui/lib/FinderAside/style.css';
import KFinderMain from '@kso/ui/lib/FinderMain';
import '@kso/ui/lib/FinderMain/style.css';
import Emitter from 'element-ui/lib/mixins/emitter';
import KCertification from '@kso/ui/lib/Certification';
import '@kso/ui/lib/Certification/style.css';
import KCertificationForbidden from '@kso/ui/lib/CertificationForbidden';
import '@kso/ui/lib/CertificationForbidden/style.css';
import { userMyTeamConf, fetchUserInfo, fetchMyCloud, fetchMyUpload, createLink, fetchCorpShareRanges, fetchFileShareInfo } from '@kso/ui/lib/request';
import { getMeetingExt } from '@kso/util';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import { subFileName, getExtName } from '@kso/ui/lib/utils';
import KUpload from '@kso/ui/lib/Upload';
import '@kso/ui/lib/Upload/style.css';
import { WEB_OFFICE } from '@kso/ui/lib/config/dotview';
import KIcon from '@kso/ui/lib/Icon';
import '@kso/ui/lib/Icon/style.css';
import { t } from '@kso/ui/lib/config/locale';
import DwWebReporter from '@kso/dw-web-reporter';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Finder = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.needCertification ? _c('KCertification', {
      attrs: {
        "from": "kpc",
        "identifyType": _vm.identifyType
      },
      on: {
        "close": _vm.onClose,
        "bindPhoneCb": _vm.bindPhoneCb
      }
    }) : _vm.certForbidden ? _c('KCertificationForbidden') : _c('div', {
      staticClass: "k-finder",
      "class": _vm.actionType
    }, [_c('KFinderAside', {
      attrs: {
        "actionType": _vm.actionType,
        "source": _vm.source,
        "src": _vm.src,
        "user": _vm.user,
        "limitedTabs": _vm.limitedTabs,
        "isSelectFile": _vm.isSelectFile,
        "showUpload": _vm.showUploadLocal,
        "limitedCompany": _vm.limitedCompany,
        "limitedMyTeams": _vm.limitedMyTeams,
        "showMyTeamTab": _vm.showMyTeamTab
      }
    }), _vm._v(" "), _c('KFinderMain', {
      ref: "main",
      attrs: {
        "user": _vm.user,
        "isSelectFile": _vm.isSelectFile,
        "isMulti": _vm.isMultiple,
        "isCrossGroup": _vm.isCrossGroup,
        "actionType": _vm.actionType,
        "secretLocked": _vm.secretLocked,
        "source": _vm.source,
        "initSource": _vm.initSource,
        "showDevices": _vm.showDevices,
        "selectedFile": _vm.selectedFile,
        "hideSecretFolder": _vm.hideSecretFolder,
        "myCloud": _vm.myCloud,
        "currentTeam": _vm.currentTeam,
        "myUpload": _vm.myUpload,
        "disableFileType": _vm.disableFileType,
        "secretFolderID": _vm.secretFolderID,
        "limitedExtArr": _vm.selectableExts,
        "limitedTabs": _vm.limitedTabs,
        "limitedCompany": _vm.limitedCompany,
        "showRename": _vm.showRename
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "k-finder-footer"
    }, [_vm.showRename ? _c('div', {
      staticClass: "rename"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: _vm.fileName,
        expression: "fileName",
        modifiers: {
          "trim": true
        }
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": _vm.fileName
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) {
            return;
          }
          _vm.fileName = $event.target.value.trim();
        },
        "blur": function blur($event) {
          return _vm.$forceUpdate();
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.showNewFolder,
        expression: "showNewFolder"
      }],
      staticClass: "new-folder",
      on: {
        "click": _vm.tryNewFolder
      }
    }, [_c('KIcon', {
      staticClass: "icon",
      attrs: {
        "type": "add-folder"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang_newBuilt))])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.isMultiple,
        expression: "isMultiple"
      }],
      staticClass: "selected-count"
    }, [_c('KIcon', {
      staticClass: "icon",
      attrs: {
        "type": "check"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang_selected) + " " + _vm._s(_vm.selectedFileIDs.length) + " " + _vm._s(_vm.lang_selectedUnit))])], 1), _vm._v(" "), _c('KButton', {
      on: {
        "click": _vm.onClose
      }
    }, [_vm._v(_vm._s(_vm.lang_cancel))]), _vm._v(" "), _c('KButton', {
      attrs: {
        "loading": _vm.committing,
        "type": "primary",
        "disabled": !_vm.showCommitButton || _vm.committing
      },
      on: {
        "click": _vm.commit
      }
    }, [_vm._v(_vm._s(_vm.okText))])], 1), _vm._v(" "), _vm.showUploadLocal && _vm.myCloud.id ? _c('k-upload', {
      attrs: {
        "containerID": "kFinder",
        "groupID": _vm.myCloud.id,
        "folderID": 0,
        "userInfo": _vm.user,
        "config": {
          enableDrag: false,
          enableMultiple: false
        }
      },
      on: {
        "success": _vm.commit
      }
    }) : _vm._e()], 1);
  },
  staticRenderFns: [],
  name: 'KFinder',
  componentName: 'KFinder',
  components: {
    KIcon: KIcon,
    KButton: KButton,
    KFinderAside: KFinderAside,
    KFinderMain: KFinderMain,
    KUpload: KUpload,
    KCertification: KCertification,
    KCertificationForbidden: KCertificationForbidden
  },
  mixins: [Emitter],
  model: {
    prop: 'committing',
    event: 'changeCommitting'
  },
  props: {
    debug: {
      type: Boolean,
      "default": false
    },
    showToast: {
      type: Boolean,
      "default": false
    },
    showNew: {
      type: Boolean,
      "default": false
    },
    showRename: {
      type: Boolean,
      "default": false
    },
    certification: {
      type: Boolean,
      "default": false
    },
    secretLocked: {
      type: Boolean,
      "default": true
    },
    actionType: {
      type: String
    },
    dwsource: {
      type: String,
      "default": 'none'
    },
    hideSecretFolder: {
      type: Boolean,
      "default": true
    },
    isSelectFile: {
      type: Boolean,
      "default": true
    },
    isMulti: {
      type: Boolean,
      "default": false
    },
    isCrossGroup: {
      type: Boolean,
      "default": false
    },
    // 配置点击确定是否开启分享并发送分享链接信息，仅限s链接
    sendShareLink: {
      type: Boolean,
      "default": false
    },
    // 配置点击确定是否发送分享链接信息优先c链接
    sendLink: {
      type: Boolean,
      "default": false
    },
    ignoreWritePermission: {
      type: Boolean,
      "default": true
    },
    // 忽略检查文件夹圈子/文件夹编辑权限
    okText: {
      type: String,
      "default": t('combine.finder.okText')
    },
    committing: {
      type: Boolean,
      "default": false
    },
    showUpload: {
      type: Boolean,
      "default": false
    },
    secretFolderID: {
      type: Number
    },
    initSource: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    disableFileType: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    initCloud: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    initUpload: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    initUser: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    limitedExtArr: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    limitedTabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    sourceFiles: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    limitedFileType: {
      type: String,
      "default": ''
    },
    limitedCompany: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    limitedMyTeams: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    // 是否为实名认证，或者是绑定手机逻辑
    identifyType: {
      type: String,
      "default": 'certification'
    }
  },
  data: function data() {
    return {
      lang_cancel: t('combine.finder.cancel'),
      lang_newBuilt: t('combine.finder.newBuilt'),
      lang_selected: t('combine.finder.selected'),
      lang_selectedUnit: t('combine.finder.selectedUnit'),
      source: {
        routeName: 'All',
        // 当前虚拟路由名称 'All', 'Team', 'Enterprise', 'Devices', 'Device', 'Secret', 'Latest', 'Sharing', 'Tags', 'Search'
        id: '',
        // 文件夹 id
        corpid: '',
        // 所在企业 id
        groupid: '',
        // 团队id
        linkgroupid: '',
        // 共享文件夹 id,
        name: '',
        // 名称
        type: '',
        // 类型
        folder_acl: {},
        // 文件夹权限
        currentTeam: {},
        // 当前团队信息
        history: false // 是否从历史记录中读取, '返回'或'前进'为true
      },
      showDevices: false,
      src: '',
      error: '',
      user: this.initUser || {},
      myCloud: this.initCloud || {},
      myUpload: this.initUpload || {},
      currentTeam: {},
      // 当前团队信息
      selectedFile: {},
      selectedFileIDs: [],
      selectFileInfoArr: [],
      bindPhone: false,
      isMacWXMini: false,
      path: [],
      // 路径
      selectableExts: [],
      fileName: '',
      selectedGroupID: '',
      certForbidden: false,
      // 实名认证手机封禁状态
      showMyTeamTab: false
    };
  },
  computed: {
    isMultiple: function isMultiple() {
      // 搜索仅支持单选
      if (this.isCrossGroup) {
        return this.isMulti;
      }
      return this.isMulti && this.source.routeName !== 'Search';
    },
    showNewFolder: function showNewFolder() {
      // 默认无新建文件夹
      if (!this.showNew) {
        return false;
      }

      // 文件选择器不显示新建
      if (this.isSelectFile) {
        return false;
      }
      if (this.error || !this.canWrite) {
        return false;
      }
      var name = this.source.routeName;
      if (name === 'Enterprise') {
        // 企业的 自动备份 文件夹,不显示新建
        return !!this.source.groupid && this.currentTeam.group_type !== 'corptmp';
      } else {
        return ~['All', 'Team', 'Secret'].indexOf(name);
      }
    },
    showUploadLocal: function showUploadLocal() {
      return this.showUpload && this.isSelectFile && !this.isMacWXMini;
    },
    showCommitButton: function showCommitButton() {
      if (this.error || !this.ignoreWritePermission && !this.canWrite) {
        return false;
      }
      if (this.currentTeam.group_type === 'corptmp' && !this.source.id) {
        return false;
      }
      if (this.isSelectFile) {
        if (this.isMultiple) {
          return this.selectedFileIDs && this.selectedFileIDs.length;
        } else {
          return this.selectedFile && this.selectedFile.id;
        }
      }
      var name = this.source.routeName;
      if (name === 'Enterprise') {
        return !!this.source.groupid;
      } else {
        return ~['All', 'Team', 'Secret', 'Device'].indexOf(name);
      }
    },
    canWrite: function canWrite() {
      if (this.source.user_role === 'read_member' || this.currentTeam.user_role === 'read_member') {
        return false;
      }
      if (this.source.folder_acl) {
        var write = true;
        var modify = this.source.folder_acl.modify;
        !modify && (write = false);
        return write;
      }
      return true;
    },
    btnTxt: function btnTxt() {
      switch (this.actionType) {
        case 'move':
          return t('combine.finder.move');
        case 'copy':
          return t('combine.finder.copy');
        case 'saveas':
          return t('combine.finder.saveas');
        default:
          return t('combine.finder.confirm');
      }
    },
    needCertification: function needCertification() {
      // 组件要求实名认证，sendShareLink||sendLink，账号未实名认证
      return this.certification && (this.sendShareLink || this.sendLink) && !this.bindPhone && !this.certForbidden;
    },
    shareErrorText: function shareErrorText() {
      return {
        notGroupMember: t('combine.finder.notGroupMember'),
        expired: t('combine.finder.expired'),
        permissionDenied: t('combine.finder.permissionDenied')
      };
    }
  },
  watch: {
    initSource: function initSource(v) {
      if (v.routeName || v.groupid) {
        this.source = v;
      }
    }
  },
  created: function created() {
    var _this = this;
    this.$on('source', function (source) {
      if (source.routeName) {
        _this.source = source;
        var routeName = source.routeName,
          linkgroupid = source.linkgroupid,
          groupid = source.groupid,
          id = source.id,
          ftype = source.ftype,
          corpid = source.corpid;
        var selectedSource = {
          routeName: routeName,
          linkgroupid: linkgroupid,
          groupid: groupid,
          id: id,
          ftype: ftype,
          corpid: corpid
        };
        _this.$emit('onSourceChange', selectedSource);
      }
    });
    this.$on('selectFile', function (selectedFile) {
      _this.selectedFile = selectedFile || {};
    });
    this.$on('selectMultiFile', function (v) {
      if (v && v.fileids) {
        _this.selectedFileIDs = v.fileids;
        _this.selectFileInfoArr = v.fileInfoArr;
        // 我的设备 currentTeam 拿不到 groupid
        _this.selectedGroupID = v.groupid;
      } else {
        _this.selectedFileIDs = [];
        _this.selectFileInfoArr = [];
      }
    });
    this.$on('commit', this.commit);
    this.$on('error', function (error) {
      _this.error = error;
    });
    this.$on('path', function (path) {
      _this.path = path;
    });
    this.$on('src', function (src) {
      _this.src = src;
    });
    this.$on('setCurrentTeam', function (team) {
      _this.currentTeam = team;
    });
    this.$on('openSecretFolder', function () {
      _this.$emit('onEnterPassword');
    });
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var requests, needFetchs, _yield$Promise$all, _yield$Promise$all2, kdMyTeamEnable, cloud, upload, user;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            requests = [
            // 异常直接不显示
            userMyTeamConf().then(function (r) {
              return r.personalTeamEnable === '1';
            })["catch"](function () {
              return false;
            }), Promise.resolve(null), Promise.resolve(null), fetchUserInfo()];
            _context.prev = 1;
            if (!_this2.myCloud.id) {
              needFetchs = [fetchMyCloud(), fetchMyUpload()];
              requests.splice.apply(requests, [1, 2].concat(needFetchs));
            }
            _context.next = 5;
            return Promise.all(requests);
          case 5:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
            kdMyTeamEnable = _yield$Promise$all2[0];
            cloud = _yield$Promise$all2[1];
            upload = _yield$Promise$all2[2];
            user = _yield$Promise$all2[3];
            if (cloud) {
              _this2.myCloud = cloud;
            }
            if (upload) {
              _this2.myUpload = upload;
            }
            if (user) {
              _this2.user = user;
            }
            _this2.showMyTeamTab = kdMyTeamEnable;
            if (_this2.user.is_company_account) {
              _this2.showMyTeamTab = false;
            }
            _this2.showDevices = _this2.user && _this2.user.is_plus;
            _context.next = 21;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](1);
          case 21:
            if (_this2.initSource && (_this2.initSource.routeName || _this2.initSource.groupid)) {
              _this2.source = _this2.initSource;
            } else if (_this2.limitedCompany.id) {
              _this2.source = {
                corpid: _this2.limitedCompany.id,
                name: _this2.limitedCompany.name,
                routeName: 'Enterprise'
              };
            } else if (_this2.$__SHIELD_CONFIG__ && _this2.$__SHIELD_CONFIG__.fileSelectorCompOnly && _this2.user && _this2.user.corp && _this2.user.corp.id) {
              _this2.source = {
                corpid: _this2.user.corp.id,
                routeName: 'Enterprise'
              };
            } else if (_this2.user.is_company_account) {
              _this2.source = {
                corpid: _this2.user.corp.id,
                routeName: 'Enterprise'
              };
            } else {
              _this2.source = {
                routeName: 'All'
              };
            }

            // 微信pc小程序ua
            if (navigator.userAgent && /miniprogramenv\/mac/i.test(navigator.userAgent.toLowerCase())) {
              _this2.isMacWXMini = true;
            }
            if (_this2.sourceFiles.length === 1 && _this2.sourceFiles[0].fname) {
              _this2.fileName = subFileName(_this2.sourceFiles[0].fname);
              _this2.fileName = "".concat(_this2.fileName, "[").concat(t('combine.finder.copy1'), "]");
            } else {
              _this2.showRename = false;
            }
            if (_this2.limitedFileType === 'weboffice') {
              _this2.selectableExts = _this2.limitedExtArr.length ? WEB_OFFICE.concat(_this2.limitedExtArr) : WEB_OFFICE;
            } else {
              _this2.selectableExts = _this2.limitedExtArr;
            }
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 19]]);
    }))();
  },
  mounted: function mounted() {
    var dwFrameOpts = {
      id: 'KFinder',
      debug: this.debug
    };
    this.$onEvent = new DwWebReporter(dwFrameOpts).onEvent;
    this.$onEvent('fileselect_action', {
      action: 'show',
      dwsource: this.dwsource
    });
  },
  methods: {
    bindPhoneCb: function bindPhoneCb(action) {
      if (action === 'bindPhoneSuccessed') this.bindPhone = true;
      if (action === 'certificationForbidden') this.certForbidden = true;
    },
    onClose: function onClose() {
      this.$emit('onClose');
    },
    commit: function commit(uploadFile) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var rawData, data, dwFrom, ext, supportExts, _data, groupid, id, ftype, name, routeName, fname, text, linkgroupid, linkData, _ref, _data2, errArr, params, _ref2, range, value, _linkData, result, msg, _result, _msg, _ref3, clink, clink_url, linktype, _params;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              rawData = {};
              if (!(_this3.currentTeam.group_type === 'corptmp' && !_this3.source.id)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              if (_this3.source.groupid || _this3.source.linkgroupid) {
                rawData = Object.assign(rawData, {
                  group_type: _this3.currentTeam.group_type
                });
              }

              // 选择文件
              if (_this3.isSelectFile) {
                // 多选
                if (_this3.isMultiple) {
                  // 我的设备 传 groupid
                  rawData = Object.assign(rawData, {
                    groupid: _this3.selectedGroupID
                  }, _this3.source);
                } else {
                  // 单选
                  rawData = _this3.selectedFile;
                }
              } else {
                // 选择文件夹
                rawData = Object.assign(rawData, _this3.source);
              }
              data = Object.assign({}, rawData);
              dwFrom = '';
              if (uploadFile) {
                dwFrom = 'Upload';
              } else if (_this3.source.routeName === 'Search') {
                dwFrom = 'Search';
              } else if (_this3.path && _this3.path.name === 'Sharing') {
                dwFrom = 'Received';
              } else {
                dwFrom = _this3.path && _this3.path.name;
              }
              if (!uploadFile) {
                _context2.next = 16;
                break;
              }
              if (!(_this3.actionType === 'meeting')) {
                _context2.next = 15;
                break;
              }
              ext = getExtName(uploadFile.name); // 注意另一个地方也有这份配置:mettingSupportType
              supportExts = ['et', 'ett', 'xls', 'xlt', 'xlsx', 'xlsm', 'xltx', 'xltm', 'csv', 'doc', 'docx', 'rtf', 'txt', 'xml', 'mhtml', 'mht', 'html', 'htm', 'uof', 'dot', 'wps', 'wpt', 'dotx', 'docm', 'dotm', 'ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps', 'pot', 'pdf', 'jpg', 'jpeg', 'png', 'gif', 'bmp', 'img', 'heic', 'webp'];
              if (supportExts.includes(ext)) {
                _context2.next = 15;
                break;
              }
              Message.error({
                type: 'error',
                message: t('combine.finder.messageErr')
              });
              return _context2.abrupt("return");
            case 15:
              data = {
                groupid: uploadFile.groupid,
                parentid: uploadFile.parentid,
                id: uploadFile.id,
                ftype: uploadFile.ftype,
                name: uploadFile.name,
                fname: uploadFile.name,
                linkgroupid: uploadFile.linkgroupid
              };
            case 16:
              _data = data, groupid = _data.groupid, id = _data.id, ftype = _data.ftype, name = _data.name, routeName = _data.routeName, fname = _data.fname, text = _data.text, linkgroupid = _data.linkgroupid;
              if (!(!uploadFile && !_this3.showCommitButton)) {
                _context2.next = 19;
                break;
              }
              return _context2.abrupt("return");
            case 19:
              if (!_this3.committing) {
                _context2.next = 21;
                break;
              }
              return _context2.abrupt("return");
            case 21:
              if (!(_this3.isSelectFile && !_this3.isMultiple && (_this3.sendLink || _this3.sendShareLink))) {
                _context2.next = 76;
                break;
              }
              if (!id) {
                _context2.next = 74;
                break;
              }
              _context2.prev = 23;
              _context2.next = 26;
              return fetchFileShareInfo(id, {
                params: {
                  with_clink: true
                }
              });
            case 26:
              linkData = _context2.sent;
              _context2.next = 68;
              break;
            case 29:
              _context2.prev = 29;
              _context2.t0 = _context2["catch"](23);
              _ref = _context2.t0.response || {}, _data2 = _ref.data;
              linkData = _data2;

              // let errArr = ['linkClosed', 'expired', 'linkExpired', 'lightLinkNotExist']
              errArr = ['lightLinkNotExist']; // 链接不存在则打开
              if (!(_data2 && errArr.includes(_data2.result))) {
                _context2.next = 64;
                break;
              }
              _context2.prev = 35;
              params = {};
              if (!_this3.source.corpid) {
                _context2.next = 49;
                break;
              }
              _context2.next = 40;
              return fetchCorpShareRanges(groupid);
            case 40:
              _context2.t1 = _context2.sent;
              if (_context2.t1) {
                _context2.next = 43;
                break;
              }
              _context2.t1 = {};
            case 43:
              _ref2 = _context2.t1;
              range = _ref2.range;
              value = range && range.value;
              if (value === 'company') {
                params = {
                  range: 'company',
                  permission: 'read'
                };
              } else if (value === 'group') {
                params = {
                  status: 'close'
                };
              }
              _context2.next = 50;
              break;
            case 49:
              params = {
                permission: 'read',
                period: 0,
                range: 'anyone',
                status: 'close'
              };
            case 50:
              _context2.next = 52;
              return createLink(id, _objectSpread({
                clink: true
              }, params));
            case 52:
              linkData = _context2.sent;
              _context2.next = 62;
              break;
            case 55:
              _context2.prev = 55;
              _context2.t2 = _context2["catch"](35);
              _linkData = _context2.t2.response && _context2.t2.response.data || {};
              if (!(_linkData && _this3.showToast)) {
                _context2.next = 62;
                break;
              }
              result = _linkData.result, msg = _linkData.msg;
              Message.error({
                type: 'error',
                message: _this3.shareErrorText[result] || msg
              });
              return _context2.abrupt("return");
            case 62:
              _context2.next = 68;
              break;
            case 64:
              if (!(_data2 && _this3.showToast)) {
                _context2.next = 68;
                break;
              }
              _result = _data2.result, _msg = _data2.msg;
              Message.error({
                type: 'error',
                message: _this3.shareErrorText[_result] || _msg
              });
              return _context2.abrupt("return");
            case 68:
              _ref3 = linkData || {}, clink = _ref3.clink, clink_url = _ref3.clink_url;
              if (clink_url) {
                linkData = Object.assign(data, {
                  groupid: groupid,
                  id: id || 0,
                  sid: clink.sid,
                  link: clink,
                  link_url: clink_url,
                  name: name || fname || text,
                  type: ftype,
                  dwFrom: dwFrom,
                  linkgroupid: linkgroupid
                });
              }
              linktype = 'fid';
              if (clink_url) {
                linktype = 'lc';
              }
              _this3.$onEvent('fileselect_action', {
                action: 'select_file_1',
                linktype: linktype,
                filetype: _this3.source.routeName.toLowerCase(),
                dwsource: _this3.dwsource
              });
              _this3.$emit('onSubmit', linkData);
            case 74:
              _context2.next = 100;
              break;
            case 76:
              _context2.prev = 76;
              if (routeName === 'All') {
                groupid = _this3.myCloud.id;
                name = t('combine.finder.docs');
              }
              if (routeName === 'Secret') {
                groupid = _this3.secretFolderID;
                name = '私密文件夹';
              }
              _this3.$data.isCommitting = true;
              _params = Object.assign(data, {
                groupid: groupid,
                id: id || 0,
                name: name || fname || text,
                type: ftype,
                linkgroupid: linkgroupid,
                actionType: _this3.actionType,
                yunfiletype: getMeetingExt(name || fname || text)
              });
              _params.extraData = {};
              _params.dwFrom = dwFrom;
              if (!(!_this3.isSelectFile && _this3.showRename)) {
                _context2.next = 90;
                break;
              }
              if (!_this3.fileName) {
                _context2.next = 88;
                break;
              }
              _params.extraData.fname = "".concat(_this3.fileName, ".").concat(getExtName(_this3.sourceFiles[0].fname, '', true));
              _context2.next = 90;
              break;
            case 88:
              Message.error({
                type: 'error',
                message: '文件名不能为空'
              });
              return _context2.abrupt("return");
            case 90:
              if (_this3.isMultiple) {
                _params.fileids = _this3.selectedFileIDs;
                _params.fileInfoArr = _this3.selectFileInfoArr;
              } else if (_this3.isMulti) {
                _params.fileids = [id];
                _params.fileInfoArr = [data];
              }
              if (_this3.isSelectFile) {
                _this3.$onEvent('fileselect_action', {
                  action: "select_file_".concat(_params.fileids && _params.fileids.length || 1),
                  linktype: 'fid',
                  filetype: _this3.source.routeName.toLowerCase(),
                  dwsource: _this3.dwsource
                });
              }
              _context2.next = 94;
              return _this3.$emit('onSubmit', _params);
            case 94:
              _this3.$data.isCommitting = false;
              _context2.next = 100;
              break;
            case 97:
              _context2.prev = 97;
              _context2.t3 = _context2["catch"](76);
              _this3.$data.isCommitting = false;
            case 100:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[23, 29], [35, 55], [76, 97]]);
      }))();
    },
    tryNewFolder: function tryNewFolder() {
      this.$emit('onNewFolder');
      this.broadcast('KFinderMain', 'tryNewFolder');
    }
  }
};

Finder.install = function (Vue) {
  Vue.component(Finder.name, Finder);
};

export { Finder as default };
